import { Component, type ErrorInfo, type ReactNode } from "react";
import { api_logError } from "../../Api/log";

type ErrorBoundaryProps = {
  children: ReactNode;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    void api_logError(error, errorInfo.componentStack ?? "");
  }

  render() {
    if (this.state.hasError) {
      return (
        <main
          className="bg-background min-h-screen min-w-screen flex flex-col items-center justify-center gap-4 p-6 text-center"
          role="alert"
        >
          <h1 className="text-xl font-bold">Something went wrong</h1>
          <p>Please reload the page and try again.</p>
          <button
            className="rounded-lg bg-primary px-5 py-2 font-semibold"
            onClick={() => window.location.reload()}
            type="button"
          >
            Reload
          </button>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
